"use strict";

class PropertyVisitorAppointmentsController {

    constructor(SSHttpService, SSAppService, SSUtilService, SSUserService, SSStorageService, SSAlertService, SSConfirmationService, SSAppointmentService) {

        const self = this;

        self.SSHttpService = SSHttpService;
        self.SSAppService = SSAppService;
        self.SSUtilService = SSUtilService;
        self.SSUserService = SSUserService;
        self.SSStorageService = SSStorageService;
        self.SSAlertService = SSAlertService;
        self.SSConfirmationService = SSConfirmationService;
        self.SSAppointmentService = SSAppointmentService;

        self.BUYER_TYPE_INDIVIDUAL = SHOWSUITE.BUYER_TYPE_INDIVIDUAL;

        self.USER_APPOINTMENT_STATUS_SCHEDULED = SHOWSUITE.USER_APPOINTMENT_STATUS_SCHEDULED;
        self.USER_APPOINTMENT_STATUS_SUCCESSFUL = SHOWSUITE.USER_APPOINTMENT_STATUS_SUCCESSFUL;
        self.USER_APPOINTMENT_STATUS_EXPIRED = SHOWSUITE.USER_APPOINTMENT_STATUS_EXPIRED;
        self.USER_APPOINTMENT_STATUS_CANCELLED = SHOWSUITE.USER_APPOINTMENT_STATUS_CANCELLED;

        self.data = SHOWSUITE.data;
        self.property = self.data.property;

        // Limit and Offset for 'buyers' search
        self.apiLimit = 10;
        self.apiOffset = 0;

        if(!self.SSUserService.getUser()){
            self.SSUserService.showLoginModal();
        }

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.buyers = [];
        self.searchParams = {};

        self.SSAppointmentService.searchFilter = self.USER_APPOINTMENT_STATUS_SCHEDULED;
        self.SSAppointmentService.start_date = moment().format("YYYY-MM-DD HH:mm:ss");
        self.SSAppointmentService.property = self.property;

        self.SSAppointmentService.limit = 10;
        self.SSAppointmentService.offset = 0;

        self.getPropertySettings();
    }

    hasPermissionForProperty(permission, property_id){
        const self = this;
        
        if(permission && property_id){
            return self.SSUserService.hasPermissionForProperty(permission, property_id);
        }
    }

    getPropertySettings(){
        const self = this;

        let url = 'sec/developer/properties/'+ self.property.id +'/settings';

        self.SSAppointmentService.getPropertySettings(url, function(response){

            if(response && response.appointment_settings){
                self.appointment_settings = response.appointment_settings;
                self.SSAppointmentService.getAppointments(self.USER_APPOINTMENT_STATUS_SCHEDULED);
            }
        });
    }

    selectAgent(){
        const self = this;

        self.hideModal();

        self.criteria = null;
        self.searched = false;
        self.agents = null;

        self.showChooseAgentModal = true;
        $('#chooseAgentModal').modal('show');
    }

    searchAgent() {
        const self = this;

        self.agents = [];
        let url = 'agents/search';
        let params = {
            criteria: self.criteria
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
          loading(false);

          if (response instanceof Error) {
            self.SSAlertService.parseAndDisplayError(response);
            return;
          }

          if (response.data && response.data.agents) {
            self.agents = response.data.agents;
          }
          self.searched = true;
        });
    }

    assignBroker(broker){
        const self = this;

        self.hideModal();

        if(!self.SSAppointmentService.appointmentParams.brokers){
            self.SSAppointmentService.appointmentParams.brokers = [];
        }

        // Don't push if already exist
        if(!self.SSAppointmentService.appointmentParams.brokers.find(x => x.user_id == broker.user_id)){
            broker.name = self.SSAppointmentService.getUserFullName(broker.user);
            self.SSAppointmentService.appointmentParams.brokers.push(broker);
        }
    }

    viewBuyers(buyers){
        const self = this;

        self.buyerIndex = 0;
        self.buyerModalData = buyers;

        self.showBuyer = true;
        $('#agentSaleApplicationBuyerModal').modal('show');
    }

    getPreviousBuyer(){
        const self = this;

        if(self.buyerIndex > 0){
            let index = self.buyerIndex - 1;
            self.buyerIndex = index;
        }
    }

    getNextBuyer(){
        const self = this;

        if(self.buyerIndex < self.buyerModalData.length - 1){
            let index = self.buyerIndex + 1;
            self.buyerIndex = index;
        }
    }

    viewAgents(agents){
        const self = this;

        self.agentIndex = 0;
        self.agentModalData = agents;

        self.showAgent = true;
        $('#agentSaleApplicationAgentModal').modal('show');
    }

    getPreviousAgent(){
        const self = this;

        if(self.agentIndex > 0){
            let index = self.agentIndex - 1;
            self.agentIndex = index;
        }
    }

    getNextAgent(){
        const self = this;

        if(self.agentIndex < self.agentModalData.length - 1){
            let index = self.agentIndex + 1;
            self.agentIndex = index;
        }
    }

    createNewBuyer() {
        const self = this;

        if (!self.validateCreateBuyer()) {
            return;
        }

        let url = 'sec/buyers';

        self.SSUserService.registerParams.individual_identity_type = "singaporean";
        self.SSUserService.registerParams.individual_national_id = "xxxx";
        self.SSUserService.registerParams.individual_nationality = 702;
        self.SSUserService.registerParams.type = self.BUYER_TYPE_INDIVIDUAL;

        loading(true);
        self.SSHttpService.postAPIRequest(url, self.SSUserService.registerParams).then(function (response) {
            if (response instanceof Error) {
                loading(false);
                self.hideModal();
                if (response.data.email_contact_value) {
                    self.SSUserService.registerErrors.email_contact_value = response.data.email[0];
                    return;
                }

                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            url = 'sec/buyers/' + response.data.buyer.id;
            let params = {
                include: 'company, individual, email_contact, phone1_contact'
            }

            self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                loading(false);
                if (response instanceof Error) {
                    self.hideModal();
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                self.SSAlertService.success("Success!", "Created a new buyer!");
                let buyer = response.data.buyers[0];
                self.buyers.push(buyer);
                self.chooseBuyer(buyer);
            });
        });
    }

    validateCreateBuyer() {
        const self = this;

        let validate = true;
        self.SSUserService.registerErrors = {};

        if (!self.SSUserService.registerParams.individual_first_name) {
            self.SSUserService.registerErrors.individual_first_name = "Please enter First Name";
            validate = false;
        }
        if (!self.SSUserService.registerParams.individual_last_name) {
            self.SSUserService.registerErrors.individual_last_name = "Please enter Last Name";
            validate = false;
        }

        if (!self.SSUserService.registerParams.email_contact_value && !self.SSUserService.registerParams.phone1_contact_value) {
            self.SSUserService.registerErrors.email_contact_value = "Please enter Email or Mobile Number";
            self.SSUserService.registerErrors.phone1_contact_value = "Please enter Email or Mobile Number";
            validate = false;
        }

        return validate;
    }

    searchBuyer() {
        const self = this;

        self.apiOffset = 0;
        self.selectedPage = 1;
        self.buyers = [];

        let url = 'sec/buyers/search';
        self.searchParams.filter_field = "email_contact_value";

        if (self.searchParams.filter_value == "" || self.searchParams.filter_value == null || self.searchParams.filter_value == undefined) {
            self.resetSearchBuyer();
        } else {
            loading(true);
            self.SSHttpService.getAPIRequest(url, self.searchParams).then(function (response) {
                loading(false);

                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);
                    return;
                }

                if(response.data && response.data.buyer) {
                    self.buyers.push(response.data.buyer);
                }
                self.count = self.buyers.length;

                self.pages = Math.ceil(self.count / self.apiLimit);
                self.selectedPage = Math.floor(self.apiOffset / self.apiLimit) + 1;
            });
        }
    }

    selectBuyer() {
        const self = this;

        self.hideModal();
        self.buyers = [];
        self.searchParams.filter_value = '';

        self.showChooseBuyerModal = true;
        $('#chooseBuyerModal').modal('show');
    }

    chooseBuyer(buyer) {
        const self = this;

        self.hideModal();

        if(!self.SSAppointmentService.appointmentParams.buyers){
            self.SSAppointmentService.appointmentParams.buyers = [];
        }

        // Don't push if already exist
        if(!self.SSAppointmentService.appointmentParams.buyers.find(x => x.id == buyer.id)){
            buyer.name = self.SSAppointmentService.getBuyerName(buyer.id, self.buyers);
            self.SSAppointmentService.appointmentParams.buyers.push(buyer);
        }
    }

    resetSearchBuyer() {
        const self = this;

        self.searchParams.filter_value = "";

        self.apiOffset = 0;
        self.selectedPage = 1;
    }

    prepareCreateBuyer() {
        const self = this;

        self.hideModal();

        self.showCreateBuyerModal = true;
        $('#createBuyerModal').modal('show');
        self.SSUserService.registerParams = {};

        self.SSUserService.maskPhoneNumber(self, 'ctrl.', 'createBuyerModal');
    }

    hideModal() {
        const self = this;

        self.showChooseAgentModal = false;
        self.showChooseBuyerModal = false;
        self.showCreateBuyerModal = false;

        if ($('#chooseAgentModal').is(':visible')) $('#chooseAgentModal').modal('hide');
        if ($('#chooseBuyerModal').is(':visible')) $('#chooseBuyerModal').modal('hide');
        if ($('#createBuyerModal').is(':visible')) $('#createBuyerModal').modal('hide');
    }
}

PropertyVisitorAppointmentsController.$inject = ['SSHttpService', 'SSAppService', 'SSUtilService', 'SSUserService', 'SSStorageService', 'SSAlertService', 'SSConfirmationService', 'SSAppointmentService'];
app.controller('PropertyVisitorAppointmentsController', PropertyVisitorAppointmentsController);

// WEB-4411/WEB-4414: `datepicker` is registered once, globally, by services/key_handover.js.
// A copy here would link it a second time on every element.
